import "./styles/index.less";
import React from "react";
import Switch from "react-router-dom/Switch";
import { IntlProvider } from "react-intl";
import { Route } from "react-router-dom";
import Main from "./Main";
import NewEnergy from "./sections/NewEnergy";
import NewPartnership from "./sections/NewPartnership";
import queryString from "query-string";
import { ScrollContext } from "react-router-scroll-4";
import $ from "jquery";
import zenscroll from "zenscroll";

import it from "./dictionaries/it";
import en from "./dictionaries/en";
import ru from "./dictionaries/ru";

const languages = {
  it,
  en,
  ru
};

function shouldUpdateScroll(prevProps, { location, history }) {
  const id = location.pathname.split("/")[1];
  if (id && id != "new-energy" && id != "new-partnership" && $(`.${id}`)) {
    // TODO: check this
    const offset = $(`.${id}`).offset()
    if (!offset) {
      return false;
    }
    const y = offset.top || 0;
    zenscroll.toY(y - 60);

    //zenscroll.toY( 60);
  }


  return false;
}

const App = React.createClass({
  getInitialState() {
    return {
      loading: false
    };
  },
  render() {
    const { userAgent, children } = this.props;
    return (
      <div>
        <Route path='/' component={AppContainer} />
      </div>
    );
  }
});

class AppContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    if (typeof window != "undefined") {
      window.jQuery = $;
      window.zenscroll = zenscroll;
    }
  }

  render() {
    const { location } = this.props;
    const languageID = queryString.parse(location.search || "?l=it").l;
    if (typeof window === "undefined") {
      return (
        <IntlProvider locale='en' messages={languages[languageID]}>
          <Switch>
            <Route path='/new-partnership' component={NewPartnership} />
            <Route path='/new-energy' component={NewEnergy} />
            <Route path='/' component={Main} />
          </Switch>
        </IntlProvider>
      );
    } else {
      return (
        <IntlProvider locale='en' messages={languages[languageID]}>
          <ScrollContext shouldUpdateScroll={shouldUpdateScroll}>
            <Switch>
              <Route path='/new-partnership' component={NewPartnership} />
              <Route path='/new-energy' component={NewEnergy} />
              <Route path='/' component={Main} />
            </Switch>
          </ScrollContext>
        </IntlProvider>
      );
    }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js